/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetBasketItemsQuery } from '../../models/get-basket-items-query';
import { GetBasketItemsQueryResult } from '../../models/get-basket-items-query-result';

export interface ApiNurseryManagerBasketGetBasketItemsPost$Plain$Params {
      body?: GetBasketItemsQuery
}

export function apiNurseryManagerBasketGetBasketItemsPost$Plain(http: HttpClient, rootUrl: string, params?: ApiNurseryManagerBasketGetBasketItemsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetBasketItemsQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiNurseryManagerBasketGetBasketItemsPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetBasketItemsQueryResult>;
    })
  );
}

apiNurseryManagerBasketGetBasketItemsPost$Plain.PATH = '/api/NurseryManager/Basket/GetBasketItems';
